import { render, staticRenderFns } from "./GlobalParameterSetup.vue?vue&type=template&id=307ab8f9&"
import script from "./GlobalParameterSetup.vue?vue&type=script&lang=ts&"
export * from "./GlobalParameterSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports